import { readCachedOrgFlag } from "./useCachedOrgFlag";

export type CodesmithSidebarVariant = "legacy" | "redesign";

export const SIDEBAR_REDESIGN_STORAGE_KEY_PREFIX =
  "codesmith-left-sidebar-redesign-enabled:";

export function readCachedSidebarRedesignEnabled(
  orgName: string | null,
): boolean {
  return readCachedOrgFlag(SIDEBAR_REDESIGN_STORAGE_KEY_PREFIX, orgName);
}

export function readCachedSidebarVariant(
  orgName: string | null,
): CodesmithSidebarVariant {
  return readCachedSidebarRedesignEnabled(orgName) ? "redesign" : "legacy";
}
